module.exports = __webpack_public_path__ + "static/media/btis-25-logo.35caeafb.png";